module.exports = __webpack_public_path__ + "img/img_platform_cultivate_village@3x.073ba178.png";